import "../../style/mobile/dashboard/M_Blog.css";
import icon1 from "../../../assets/mobile/dashboard/vuesax-linear-book.svg";
import icon2 from "../../../assets/mobile/dashboard/Vector.svg";
import img1 from "../../../assets/mobile/dashboard/joyce-adams-eF_3z15RmWY-unsplash.png";
import Slider from "react-slick";

let weblog_data = [
  {
    id: 1,
    title: "آیا عصر دایناسور های به پایان رسیده؟",
    img: img1,
    subtitle:
      "به نظر شما زمان آن نرسیده که از خود این سوال را بپرسیم چرا دایناسورها رامنقرض کردیم؟",
    badge: "برچسب",
    reading_time: 5,
  },
  {
    id: 2,
    title: "سرنوشت ببر مازندران چه شد؟",
    img: img1,
    subtitle:
      "به نظر شما زمان آن نرسیده که از خود این سوال را بپرسیم چرا دایناسورها رامنقرض کردیم؟",
    badge: "برچسب",
    reading_time: 4,
  },
];

const M_Blog = () => {
  var settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1.2,
    slidesToScroll: 1,
    arrows: false,
    className: "M-Blog-tab-content-slider-item",
  };
  return (
    <div className="M_Blog">
      <div className="M_Blog_title-box">
        <img src={icon1} className="M_Blog_title-box-icon" alt="" />
        <div className="M_Blog_title-box-text">از وبلاگ</div>
      </div>
      <div className="M_Blog-content">
        <Slider {...settings}>
          {weblog_data.map((item) => (
            <div className="M_Blog-content-item" key={item.id}>
              <div className="M_Blog-content-item-img-container">
                <img src={item.img} alt="blog-img" />
              </div>
              <div className="M_Blog-content-item-text">
                <div className="M_Blog-content-item-text-title">
                  {item.title}
                </div>
                <div className="M_Blog-content-item-text-subtitle">
                  {item.subtitle}
                </div>
              </div>
              <div className="M_Blog-content-item-badge">{item.badge}</div>
              <div className="M_Blog-content-item-time-box">
                <img
                  src={icon2}
                  className="M_Blog-content-item-time-box-img"
                  alt=""
                />
                <div className="M_Blog-content-item-time-box-text">
                  زمان مطالعه {item.reading_time} دقیقه
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default M_Blog;
